export const environment = {
  production: false,
  //apiUrl: 'http://192.248.179.45/api'
  apiUrl: 'https://salesmanager.store/api'
};